import { useEffect, useState } from 'react';
import './rodape.component.scss';
import { buscarTextoRodape } from '../../services/busca-rodape';
import { alertService } from '../../services/alertService';
import { useTranslation } from 'react-i18next';

const RodapeComponent = () => {

    const { t } = useTranslation();
    const [rodape, setRodape] = useState('');

    useEffect(() => {
        buscarTextoRodape()
            .then((response: string) => setRodape(response))
            .catch((erro: string) => {
                console.error(erro);
                alertService.toast(t("FOOTER_FETCH_ERROR"), 'error');
            });
    }, [t]);

    return (
        <footer className="rodape-component rodape-component--style">
            <span>{rodape}</span>
        </footer>
    );
};

export { RodapeComponent };
